module Meevo.Plugins.MembershipManager {

    export function dateDisplayFilter() {
        return (input: string): string => {

            if (!input) {
                return "";
            }

            return moment(input).format('ddd M/DD/YYYY h:MM:ss A')
        };
    }


    angular.module("meevo.components.controls")
        .filter("dateDisplayFilter", dateDisplayFilter);
}
